// A company opens a Kolvantage account (when platform admins opened sign-up): the account and
// its owner, who is logged in right away and adds the first website.
import { api } from './format.js';

const form = document.getElementById('signup-form');
const error = document.getElementById('signup-error');

fetch('/api/auth/me').then((res) => {
  if (res.ok) location.replace('./');
});

api('/auth/options')
  .then((o) => {
    form.hidden = !o.signup;
    document.getElementById('signup-closed').hidden = !!o.signup;
    if (o.signup) form.elements.company.focus();
  })
  .catch(() => (document.getElementById('signup-closed').hidden = false));

form.addEventListener('submit', async (e) => {
  e.preventDefault();
  const submit = form.querySelector('[type=submit]');
  submit.disabled = true;
  error.hidden = true;
  const f = form.elements;
  try {
    await api('/auth/signup', { method: 'POST', body: { company: f.company.value, name: f.name.value, email: f.email.value, password: f.password.value } });
    location.replace('./');
  } catch (err) {
    error.textContent = err.message;
    error.hidden = false;
    submit.disabled = false;
  }
});
